// Parts of a league name to hide for a customer (the path slug, not the ?user= theme), by league id.
// Typically a competitor's brand that the customer does not want to display.
const HIDDEN_LEAGUE_NAME_PARTS: Record<string, Record<number, string[]>> = {
  winline: {
    5559: ['1win'] // 1win Private Club
  }
};

export { HIDDEN_LEAGUE_NAME_PARTS };
